<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label class="form-label">Company</label>
                    </div>
                    <div class="col-md-12">
                        <input type="hidden"
                               name="company"
                               :value="companyId">
                        <multiselect
                            data-test="selected-company"
                            v-model="selectedCompany"
                            :options="company"
                            track-by="name"
                            label="name"
                            placeholder="Choose company"
                            :allow-empty="true"
                            :multiple="false"
                            :close-on-select="true"
                            :style="{ height: 'auto'}"
                        >
                            <template #noResult>
                              <span>
                                  Company not found. Consider changing the query.
                              </span>
                            </template>
                        </multiselect>
                        <validation-error :errors="getErrorMessages('company')" :class="'validation-alert'"></validation-error>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="customType === 'individuals'">
            <div class="row">
                <div class="col-md-4">
                    <div class="row margined-bottom">
                        <div class="col-md-12">
                            <label class="control-label">Users</label>
                        </div>
                        <div class="col-md-12">
                            <input v-for="user in form.users" :key="user.id" type="hidden" name="users[]" :value="user.id">
                            <user-search-component
                                :disabled="!companyId"
                                :company-id="companyId"
                                not-found-message="Customer not found. Consider changing the query."
                                :field="searchField"
                                :role="roles"
                                :trigger-text="''"
                                :as-mail-input="true"
                                :centre_id="centreId"
                                :multiple="true"
                                :default-users="old.users"
                            ></user-search-component>
                            <validation-error :errors="getErrorMessages('users')" :class="'validation-alert'"></validation-error>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div v-if="form.users.length > 0" >
                        <table class="table table-hover table-borderless">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th width="20"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in form.users" :key="user.id">
                                <td>
                                    <a href="javascript:void(0)">{{ user.full_name }}</a>
                                </td>
                                <td>{{ user.email }}</td>
                                <td align="center">
                                    <button type="button" class="btn btn-danger unselect-user" v-on:click="unSelectUser(user)">
                                        <span class="fa fa-close"></span>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label>Accessible Zones</label>
                    </div>
                    <div class="col-md-12">
                        <input v-for="zone in selectedZones" :key="zone.id" type="hidden" name="zones[]" :value="zone.id">
                        <multiselect
                            data-test="selected-zones"
                            v-model="selectedZones"
                            :disabled="!companyId"
                            :options="zones"
                            track-by="name"
                            label="name"
                            placeholder="Choose Accessible Zones"
                            :searchable="true"
                            :loading="loadingZones"
                            :internal-search="true"
                            :allow-empty="true"
                            :multiple="true"
                            :close-on-select="false"
                            :style="{ height: 'auto'}"
                        ></multiselect>
                        <validation-error :errors="getErrorMessages('zones')" :class="'validation-alert'"></validation-error>
                    </div>
                </div>
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label>Accessible Offices</label>
                    </div>
                    <div class="col-md-12">
                        <input v-for="inventory in selectedInventories" type="hidden" name="inventories[]" :key="inventory.id" :value="inventory.id">
                        <multiselect
                            :disabled="!companyId"
                            v-model="selectedInventories"
                            :options="inventories"
                            track-by="fullName"
                            label="fullName"
                            placeholder="Choose Accessible Offices"
                            :searchable="true"
                            :loading="loadingInventories"
                            :internal-search="true"
                            :allow-empty="true"
                            :multiple="true"
                            :close-on-select="false"
                            :style="{ height: 'auto'}"
                        ></multiselect>
                        <validation-error :errors="getErrorMessages('inventories')" :class="'validation-alert'"></validation-error>
                    </div>
                </div>
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label for="end_date">
                            <span>Valid Until ({{ diffInDays }} days max)</span>
                        </label>
                    </div>
                    <div class="col-md-12">
                        <input type="text" name="end_date"  class="form-control" :disabled="!companyId" :value="form.end_date" @focus="initDatePicker" />
                        <validation-error :errors="errors.end_date" :class="'validation-alert'"></validation-error>
                    </div>
                    <div class="col-md-12">
                        <div class="form-check">
                            <input class="form-check-input" :disabled="!companyId" v-model="maxAllowedDateCheckBox" type="checkbox" id="max-allowed-date"/>
                            <label for="max-allowed-date" class="form-check-label">Until maximum allowed: {{ maxAllowedDate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row margined-bottom">
                    <div class="col-12">
                        <div class="form-check">
                            <div class="row">
                                <div class="col-6">
                                    <input class="form-check-input" :disabled="!companyId" type="radio" name="hours" v-model="form.hours" value="business" id="hours-business"/>
                                    <label class="form-check-label" for="hours-business">Business Hours Only</label>
                                </div>
                                <div class="col-6">
                                    <input class="form-check-input" :disabled="!companyId" type="radio" name="hours" v-model="form.hours" value="24-hours" id="hours-24-hours"/>
                                    <label class="form-check-label" for="hours-24-hours">24 hours access</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <label for="reason_for_request">Provide the reason for this request</label>
                    </div>
                    <div class="col-md-12">
                        <textarea :disabled="!companyId" class="reason-for-request" name="reason_for_request" id="reason_for_request" rows="5" v-model="form.reason_for_request"></textarea>
                        <validation-error :errors="errors.reason_for_request" :class="'validation-alert'"></validation-error>
                    </div>
                </div>
                <div class="row margined-bottom">
                    <div class="col-md-12">
                        <form-sender-button
                            :alert-text="senderWarning"
                            :form-id="'custom-access-form'"
                            :btn-text="btnText"
                        ></form-sender-button>
                        <a type="button" class="btn btn-danger float-end" :href="previousUrl"> Cancel </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from '../EventBus';
import Multiselect from 'vue-multiselect';
import UserSearchComponent from './Shared/UserSearchComponent.vue';
import ValidationError from './UI/ValidationError.vue';
import Inventories from "../Services/Inventories";
import Access from "../Services/Access";
import InventoryGroups from "../Services/InventoryGroups";
import get from "lodash/get";
import Utils from '../Services/Utils'
import dayjs from "dayjs";
import {TempusDominus} from "@eonasdan/tempus-dominus";
import {formatDate} from "../Services/DateUtils";

export default {
        name: "CustomAccessFormComponent",
        components: {
            UserSearchComponent,
            ValidationError,
            Multiselect
        },
        props: {
            centreId: {
                type: Number,
                required: true
            },
            dateFormat:{
                type: String,
                required: true
            },
            roles: {
                type: Array
            },
            searchField: {
                type: Array
            },
            old: {
                type: [Object, Array]
            },
            errors: {
                type: [Object, Array]
            },
            previousUrl: {
                type: String,
                default: ""
            },
            btnText: {
                type: String,
                default: "Send"
            },
            customType: {
                type: String,
                default: 'individuals'
            },
            senderWarning: {
                type: String,
                default: "Are you sure?"
            },
            company: {
                type: Array,
                required: true,
            }
        },
        data: function() {
            return {
                form: {
                    hours: 'business',
                    ...this.old,
                    users: [],
                },
                zones: [],
                inventories: [],
                loadingZones: false,
                loadingInventories: false,
                maxAllowedDateCheckBox: null,
                diffInDays: null,
                selectedCompany: this.company.find(({id}) => id == this.old.company),
                selectedZones: null,
                selectedInventories: null,
                maxAllowedDate: null,
                datePickerOptions: {
                    format: this.dateFormat.toUpperCase()
                        .replace("Y", "yyyy")
                        .replace("M", "MM")
                        .replace("D", "dd"),
                    minDate: dayjs().startOf('day').toDate(),
                    maxDate: this.maxAllowedDate,
                },
                today: dayjs().format(this.dateFormat),
                datePicker: null
            }
        },
        computed: {
            companyId() {
                return this.selectedCompany?.id
            }
        },
        mounted() {
            EventBus.on('user-selected', this.userSelected);
            EventBus.on('user-unselected', this.userUnSelected);
            EventBus.on('all-forms-cancelled', this.clearForm);

            this.getZones();
            this.getInventories();
        },
        methods: {
            unSelectUser(user) {
                EventBus.emit('user-unselected', user);
            },

            userSelected(user) {
                this.form.users.push(user);
            },

            userUnSelected(user) {
                this.form.users = this.form.users.filter(u => u.id !== user.id);
            },

            getZones() {
                this.loadingZones = true;
                InventoryGroups.listWithoutCommsRoom(this.centreId).then(zones => {
                    this.zones = zones;
                    this.loadingZones = false;
                    this.setOldZones();
                });
            },

            getInventories() {
                this.loadingInventories = true;
                Inventories.list(this.centreId).then(inventories => {
                    this.inventories = inventories.map(inventory => {
                        inventory.fullName = `${inventory.name} - ${get(inventory, 'product.name', '')}`;
                        return inventory;
                    });
                    this.loadingInventories = false;
                    this.setOldInventories();
                });
            },

            setOldZones() {
                if (!this.old.zones) {
                    return;
                }

                this.selectedZones = this.zones.filter(z => this.old.zones.includes(z.id.toString()));
            },

            setOldInventories() {
                if (!this.old.inventories) {
                    return;
                }

                this.selectedInventories = this.inventories.filter(i => this.old.inventories.includes(i.id.toString()));
            },

            clearForm() {
                this.form = {
                    hours: 'business',
                    users: [],
                };
                this.selectedZones = null;
                this.selectedInventories = null;
                this.maxAllowedDate = null;
                this.datePickerOptions.maxDate = null;
                this.diffInDays = null;
            },

            getErrorMessages(key) {
                return Utils.getErrorMessages(this.errors, key);
            },

            setMaxCustomAccessDateLabel(){
                if(!this.companyId || !this.centreId){
                    return;
                }

                Access.getMaxCustomAccessDate(this.centreId, this.companyId).then(res => {
                    this.maxAllowedDate = formatDate(res.date, this.dateFormat);
                    this.datePickerOptions.maxDate = dayjs(res.date).toDate();
                    this.diffInDays = res.diffInDays
                    this.setHoursRadioButtonValue()
                });
            },
            setHoursRadioButtonValue(){
                this.form.hours = dayjs(this.today).isSame(this.maxAllowedDate) ? '24-hours' : 'business';
            },
            setDatePickerValue(res){
                this.form.end_date = res;
            },
            initDatePicker() {
                if (this.datePicker) {
                    return;
                }
                const input = event.target;
                this.datePicker = new TempusDominus(input, {
                    display: {
                        components: {
                            clock: false
                        }
                    },
                    localization: {
                        format: this.datePickerOptions.format
                    },
                    restrictions: {
                        minDate: this.datePickerOptions.minDate,
                        maxDate: this.datePickerOptions.maxDate
                    }
                });
                input.addEventListener('change.td', () => {
                    this.updateFormProperty(input);
                })
            },
            updateFormProperty(input) {
                const propertyName = input.name;
                const newValue = input.value;
                this.$set(this.form, propertyName, newValue);
            }
        },
        watch: {
            companyId: {
                handler() {
                    this.setMaxCustomAccessDateLabel()
                },
                immediate: true
            },
            selectedCompany() {
                EventBus.emit('all-forms-cancelled')
            },
            maxAllowedDateCheckBox(checked) {
                if (!checked) {
                    this.setDatePickerValue(null)
                    return;
                }

                this.setDatePickerValue(this.maxAllowedDate)
            }
        }
    }
</script>

<style scoped>
    .btn.unselect-user{
        padding: 1px 6px 1px 6px;
    }
    .btn.unselect-user span {
        margin-right: -1px;
    }
    .reason-for-request{
        width: 100%;
    }
</style>
